import { render } from "./JzButton.vue?vue&type=template&id=4e160d73&scoped=true"
import script from "./JzButton.vue?vue&type=script&lang=js"
export * from "./JzButton.vue?vue&type=script&lang=js"

import "./JzButton.vue?vue&type=style&index=0&id=4e160d73&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e160d73"]])

export default __exports__